import CTAButton from "components/CTAButton";
import Modal from "features/Modal/Modal";
import { ModalBody, ModalButtonWrapper } from "features/Modal/styled";
import React from "react";

function UnexpectedErrorModal({ closeModal }: { closeModal: () => void }) {
  return (
    <Modal title="Something went wrong" closeModal={closeModal}>
      <ModalBody>
        <p>Something went wrong. Please try again.</p>
      </ModalBody>
      <ModalButtonWrapper>
        <CTAButton onClick={closeModal}>OK</CTAButton>
      </ModalButtonWrapper>
    </Modal>
  );
}

export default UnexpectedErrorModal;
